var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeClockBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 44.3652C12.9543 44.3652 4 35.4108 4 24.3652C4 13.3195 12.9543 4.36523 24 4.36523C35.0456 4.36523 44 13.3195 44 24.3652C44 35.4108 35.0456 44.3652 24 44.3652ZM24 40.3652C32.8366 40.3652 40 33.2018 40 24.3652C40 15.5287 32.8366 8.36523 24 8.36523C15.1634 8.36523 8 15.5287 8 24.3652C8 33.2018 15.1634 40.3652 24 40.3652ZM26 24.3652H34V28.3652H22V14.3652H26V24.3652Z",
    fill: "#3940A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeClockBlue);
export default __webpack_public_path__ + "static/media/TimeClockBlue.9188288d41c0d398decf71048245ff70.svg";
export { ForwardRef as ReactComponent };